import { schema } from "normalizr";
import { revisionSchema } from "../revision";

export const seriesSchema = new schema.Entity("series", {
  revisions: [revisionSchema]
});
